import { getFeedsComments, getRealtimeSteamingTable } from '@op/services';
import { DownloadConfigInfoType } from '../types';
import { sentimentNumber, validationValue } from '../renderHelper';
import { sentimentFormat } from '@op/utils/value';

export const RealtimeStreamingTable: DownloadConfigInfoType = {
  type: 'page',
  columns: ({ filter }) => {
    const tableColumns: any = [
      {
        key: 'current_rank',
        header: 'Rank',
      },
      {
        key: 'live_anchors',
        header: 'Streamer',
      },
      {
        key: 'anchors_followers',
        header: 'Followers',
      },
      {
        key: 'live_title',
        header: 'Title',
      },
      {
        key: 'live_time',
        header: 'Stream Start Time',
      },
      {
        key: 'live_viewer',
        header: !filter.only_live_streaming ? 'PCV' : 'CCV',
      },
    ];

    return tableColumns;
  },
  downloadFunc: filter => getRealtimeSteamingTable({ data: filter }),
};

export const RealtimeStreamingTrendAnalysis: DownloadConfigInfoType = {
  columns: () => {
    const tableColumns: any = [
      {
        key: 'time',
        header: 'Date',
      },
      {
        key: 'playback_time',
        header: 'Playback Time',
      },
      {
        key: 'mentions',
        header: 'Number of Live Chats',
      },
      {
        key: 'avg_sentiment',
        header: 'Live Chats Sentiment',
        renderHelper: [sentimentNumber],
        format: (value: number) => Number(sentimentFormat(value)),
        numFmt: '0.00',
      },
      // {
      //   key: 'topics_avg_sentiment',
      //   header: 'Streamer Sentiment',
      //   renderHelper: [sentimentValue],
      // },
      {
        key: 'topics',
        header: `Streamer's Ongoing Topics`,
      },
    ];

    return tableColumns;
  },
};

export const RealtimeStreamingDetailTable: DownloadConfigInfoType = {
  type: 'page',
  columns: () => {
    const tableColumns: any = [
      {
        key: 'content',
        header: 'Live Chats in Original Language',
      },
      {
        key: 'content_to_en',
        header: 'Live Chats in English Language',
      },
      {
        key: 'content_to_zh',
        header: 'Live Chats in Chinese Language',
      },
      {
        key: 'sentiment_rating',
        header: 'Sentiment',
      },
      {
        key: 'topic',
        header: 'Topic',
      },
      {
        key: 'isvalid',
        header: 'Validation',
        renderHelper: [validationValue],
      },
      {
        key: 'content_length_no_space',
        header: 'Character Length',
      },
      {
        key: 'comment_time',
        header: 'Time',
      },
    ];

    return tableColumns;
  },
  downloadFunc: getFeedsComments,
};
